var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.side = {
	init : function () {
		if ($('body').hasClass('hasSide')) {
			var $side = $('#side');
			$side.removeClass('hidden');
			$('#main > .box').append($side);
		}
	}
};
site.inits.push('site.side.init()');

site.faq = {
	init : function() {
		var $faq = $('#faq, .box_faqCategory, .bokun__faq');
		if ($faq.length == 0) return false;

		$('.answer', $faq).each(function() {
				$(this).css('max-height', $(this)[0].scrollHeight);
		});

		$(window).resize(function() {
				$('.answer', $faq).each(function() {
						$(this).css('max-height', $(this)[0].scrollHeight);
				});
		});

		$faq.find('.question').click(function() {
				$(this).parent('li').toggleClass('open');
		});
		$faq.find('#cancel').click(function() {
				window.history.back();
		});
	}
};
site.inits.push('site.faq.init()');

// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.bokun = {
	init: function() {
		$('#bokunBookNow').on('click', function() {
			$('body').addClass('bokunOpen');
		});

		$('.bokun__close').on('click', function() {
			$('body').removeClass('bokunOpen');
		});
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	/*$('.qn .btn', '#header').click(function(e) {
		$('body').removeClass('mainmenu-open');
		$('body').toggleClass('dropdown-open');

		$('body.dropdown-open').on('click', function (e) {
			$('body').removeClass('dropdown-open');
		});
		e.stopPropagation();
		e.preventDefault();
	});*/

	$('#dropdown').on('click', function(e) {
		e.stopPropagation();
	});

	$('#drop-close').click(function(e) {
		e.preventDefault();
		$('body').removeClass('dropdown-open');
	});

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	if ($('body').hasClass('frontpage')) {
		site.sticky.box('.box_advert.first .logo', 'stickyHead', 14);
		$('.logo a', '#header').click(function(e) {
			e.preventDefault();
			$('html, body').animate({scrollTop:0 }, 0);
			$('body').removeClass('mainmenu-open');
			$('body').removeClass('dropdown-open');

		});

		if ($(window).scrollTop() < 200 && $(window).width() + 15 > 992) {
			$('#main .image, #main .promos .item, #main .category > .description').inViewport(function(px){
				if(px) $(this).addClass("animated fadeInUp") ;
			});
		}
	}

	$('.items .item:nth-child(n+5)', '#mainmenuTiles').wrapAll('<div class="lastWrap"></div>');
	$('.items', '#below').prepend('<div class="hidden"></div>');

	site.owl.init('#extras .item .images, #below .item .images', {
		loop: true,
		mouseDrag: false,
		nav: true,
		navText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
		dots: false,
		animateOut: 'fadeOut',
		animateIn: 'fadeIn',
		items: 1
	});
	site.owl.init('#tripadvisorCarousel .items', {
		loop:true,
		nav:true,
		navText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
		dots: false,

		items: 1
	});
	$('a', '#submenu').on('click', function(e) {
		var location = $(this).attr('href');
		if (location.startsWith('#')) {
			$('html, body').animate({scrollTop:$(location).offset().top}, 'slow');
			e.preventDefault();
			window.location.hash = location.substring(1);
		}
	});

	$('#galleryAlbumImages').mixItUp({
		animation: {
			duration: 0
		}
	});

	$('.mixitup-filter').click(function(e) {
		e.preventDefault();
	});

	site.bokun.init();
	site.spjallmenni.init();

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
